import styled from '@emotion/styled'

import { toggleButton } from '../../design/tokens'

const handleSelected = ({ $selected }) =>
  $selected ? `color: ${toggleButton.color.text.selected};` : ''

const handleDisabled = () =>
  `
    &[disabled] {
      color: ${toggleButton.color.text.disabled};
      
      cursor: not-allowed;
    }

    &[disabled] > * {
      opacity: ${toggleButton.opacity.disabled};
    }
`

const handlePadding = ({ $padding }) =>
  $padding ? `padding: ${$padding};` : ''

export const StyledToggleButton = styled.button`
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;

  outline: none;

  height: ${toggleButton.height};

  ${handlePadding}

  border-radius: ${toggleButton.borderRadius};
  border-width: ${toggleButton.borderWidth};
  border-style: solid;

  color: ${toggleButton.color.text.default};
  background-color: ${toggleButton.color.background.default};

  border-color: ${toggleButton.color.border.default};

  cursor: pointer;

  ${handleSelected}
  ${handleDisabled}


  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    color: ${toggleButton.color.text.hover};
    border-color: ${toggleButton.color.border.hover};
  }
`
